/* RWM – Extra carrello (busta regalo + suggerimenti sotto 10€) */
(function () {
  if (window.RWMCartExtras) return;
  var SEL = '[data-rwm-cart-extras]';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lastSig = null;
  var busy = false;
  var timer = null;

  function json(url, body) {
    return fetch(root + url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (r) {
      return r.json();
    });
  }

  function isCartPage() {
    return /\/cart\/?$/.test(location.pathname);
  }

  // Fa ri-renderizzare il carrello a Kalles dopo una modifica
  function refreshTheme() {
    if (isCartPage()) {
      location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    lastSig = null;
    schedule(400);
  }

  function setMsg(text) {
    document.querySelectorAll('[data-rwm-cx-msg]').forEach(function (el) {
      el.textContent = text;
      el.hidden = !text;
    });
  }

  function render(cart) {
    var holders = document.querySelectorAll(SEL);
    if (!holders.length) return Promise.resolve();
    if (cart.item_count === 0) {
      holders.forEach(function (h) {
        h.innerHTML = '';
      });
      return Promise.resolve();
    }
    var bagHandleId = holders[0].getAttribute('data-bag-pid');
    var first = cart.items.find(function (i) {
      return String(i.product_id) !== bagHandleId;
    });
    var url = first
      ? 'recommendations/products?product_id=' + first.product_id + '&limit=10&section_id=rwm-cart-extras'
      : '?section_id=rwm-cart-extras';
    return fetch(root + url)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var box = doc.querySelector('[data-rwm-cx-root]');
        if (!box) return;
        holders.forEach(function (h) {
          h.innerHTML = box.outerHTML;
        });
        return enforceBag(box);
      });
  }

  // Regole busta: max 1, piccola solo fino a 3 prodotti, niente busta senza prodotti
  function enforceBag(box) {
    var small = box.getAttribute('data-bag-small');
    var large = box.getAttribute('data-bag-large');
    if (!small) return;
    var qty = parseInt(box.getAttribute('data-products-qty'), 10) || 0;
    var bagQty = parseInt(box.getAttribute('data-bag-qty'), 10) || 0;
    var bagVar = box.getAttribute('data-bag-variant');
    if (!bagQty) return;
    var updates = {};
    var msg = '';
    if (qty === 0) {
      updates[small] = 0;
      updates[large] = 0;
    } else if (bagVar === small && qty > 3) {
      updates[small] = 0;
      updates[large] = 1;
      msg = 'La busta piccola contiene fino a 3 prodotti: abbiamo selezionato la busta grande.';
    } else if (bagQty > 1) {
      updates[bagVar] = 1;
    } else {
      return;
    }
    return json('cart/update.js', { updates: updates }).then(function () {
      refreshTheme();
      if (msg) setTimeout(function () { setMsg(msg); }, 1200);
    });
  }

  function update() {
    if (busy) return;
    if (!document.querySelector(SEL)) return;
    busy = true;
    json('cart.js')
      .then(function (cart) {
        var sig = cart.token + '|' + cart.item_count + '|' + cart.total_price + '|' + cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join(',');
        var empty = Array.prototype.some.call(document.querySelectorAll(SEL), function (h) {
          return !h.firstElementChild;
        });
        if (sig === lastSig && !(empty && cart.item_count > 0)) return;
        lastSig = sig;
        return render(cart);
      })
      .catch(function (e) {
        console.warn('RWM cart extras', e);
      })
      .then(function () {
        busy = false;
      });
  }

  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(update, ms || 250);
  }

  document.addEventListener('click', function (e) {
    var bagBtn = e.target.closest('[data-rwm-bag]');
    var addBtn = e.target.closest('[data-rwm-add]');
    if (bagBtn) {
      e.preventDefault();
      if (bagBtn.disabled || bagBtn.classList.contains('is-active')) return;
      var box = bagBtn.closest('[data-rwm-cx-root]');
      var small = box.getAttribute('data-bag-small');
      var large = box.getAttribute('data-bag-large');
      var chosen = bagBtn.getAttribute('data-rwm-bag');
      var updates = {};
      updates[small] = chosen === small ? 1 : 0;
      updates[large] = chosen === large ? 1 : 0;
      box.classList.add('is-loading');
      json('cart/update.js', { updates: updates }).then(refreshTheme);
    } else if (addBtn) {
      e.preventDefault();
      var card = addBtn.closest('.rwm-cx__card');
      var sel = card && card.querySelector('[data-rwm-variant]');
      var id = sel ? sel.value : addBtn.getAttribute('data-rwm-add');
      addBtn.classList.add('is-loading');
      addBtn.disabled = true;
      json('cart/add.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] }).then(refreshTheme);
    }
  });

  // Kalles sostituisce parti del carrello via AJAX: osserva il DOM e riallinea
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t.nodeType !== 1 || !t.closest || t.closest(SEL)) continue;
      if (t.closest('#t4s-mini_cart, [data-cart-wrapper]') || t.querySelector(SEL)) {
        schedule();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('cart:update:count', function () {
    schedule();
  });

  window.RWMCartExtras = { update: update };
  schedule(50);
})();
